export default "__VITE_ASSET__CXY2HPM0__"